<!-- eslint-disable max-lines -->
<template>
  <div :class="['widget', {'border-error': error}]">

    <v-container style="height: 50%">
      <v-layout
        align-center
        justify-space-between>
        <a
          :href="url"
          class="subheading clickable">
          Zabbix events</a>
        <v-btn
          :disabled="posting"
          class="ma-0"
          color="green"
          outline
          small
          @click="openIssue">
          <v-progress-circular
            v-if="posting"
            size="15"
            indeterminate/>
          <span v-else>Open an issue</span>
        </v-btn>
      </v-layout>

      <template v-if="loading">
        <v-layout
          align-center
          justify-center
          fill-height>
          <v-progress-circular
            size="50"
            indeterminate/>
        </v-layout>
      </template>

      <template v-else>
        <v-container style="padding: 12px 24px 0 24px;">
          <table style="table-layout: fixed; width: 100%;">
            <tr>
              <td
                colspan="3"
                class="text-xs-left grey--text">
                Description
              </td>
              <td class="text-xs-right grey--text">Start</td>
              <td class="text-xs-right grey--text">Duration</td>
            </tr>
            <tr
              v-for="evt in events"
              :key="evt.dateRaised + evt.trigger">
              <td colspan="3">
                {{ evt.trigger }}
              </td>
              <td class="text-xs-right">
                <v-tooltip left>
                  <span slot="activator">
                    {{ evt.dateRaised | formatFn }}
                  </span>
                  <span>{{ evt.dateRaised | formatLLL }}</span>
                </v-tooltip>
              </td>
              <td
                :class="[
                  'text-xs-right',
                  { 'blink red--text text--accent-3': !evt.dateClosed }
              ]">
                <v-tooltip
                  v-if="evt.dateClosed"
                  left>
                  <span slot="activator">
                    {{ [evt.dateClosed, evt.dateRaised] | duration }}
                  </span>
                  <span>{{ evt.dateClosed | formatLLL }}</span>
                </v-tooltip>
                <span v-else>
                  {{ [evt.dateClosed, evt.dateRaised] | duration }}
                </span>
              </td>
            </tr>
          </table>
        </v-container>
      </template>
    </v-container>
  </div>
</template>

<script>
import moment from "moment";

export default {
  name: "zabbix-events",
  filters: {
    duration (val) {
      const end = val[0] ? moment(val[0]) : moment();
      const start = moment(val[1]);
      return moment.duration(start.diff(end)).humanize();
    }
  },
  data () {
    return {
      error: false,
      events: [],
      hostId: 0,
      loading: false,
      posting: false
    };
  },
  computed: {
    url () {
      const base = "https://au.zabbix.thinxtra.com";
      return `${base}/zabbix/events.php?hostid=${this.hostId}`;
    }
  },
  created () {
    this.loading = true;
    Promise.all([
      this.$http.get(`/api/sites/${this.$route.params.id}/zabbix_events`),
      this.$http.get(`/api/sites/${this.$route.params.id}/zabbix_id`)
    ]).
      then(([events, id]) => {
        this.events = events.data;
        this.hostId = id.data.hostId;
      }).
      catch(() => this.error = true).
      finally(() => this.loading = false);
  },
  methods: {
    openIssue () {
      this.posting = true;
      this.$http.
        post("/api/issues", {
          dateRaised: moment().format("YYYY-MM-DDTHH:mm:ss"),
          site: this.$route.params.id
        }).
        then((r) => {
          this.$http.get("/api/issues");
          this.$router.push({
            name: "issue",
            params: { id: r.data.id }
          });
        }).
        finally(() => this.posting = false);
    }
  }
};
</script>

<style scoped>
.blink {
  animation: blinker 1s linear infinite;
}
@keyframes blinker {
  50% {
    opacity: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Site/ZabbixEvents.vue